'use client';

import Button from '@/components/atoms/shared/Button';
import Page from '@/components/atoms/shared/Page';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useRouter } from 'next/navigation';
import React from 'react';

const RedirectButton = () => {
  const router = useRouter();
  return (
    <>
      <Button
        variant="blue"
        onClick={() => {
          window.location.reload();
        }}
        className="flex-1"
        size="lg"
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        새로고침
      </Button>
      <Button variant="solid" intent="neutral" onClick={() => {
        window.history.back();
        window.location.reload();
      }} className="flex-1" size="lg">
        이전 페이지로
      </Button>
    </>
  );
};

/**
 * 페이지 에러 fallback view
 */
export default function ErrorFallbackView({
  msg,
  customButton,
}: {
  msg?: string;
  customButton?: React.ReactNode;
}) {
  return (
    <Page>
      <div className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-6">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <AlertTriangle className="h-6 w-6 text-red-600" />
        </div>
        <p className="text-xl text-gray-600">실행 도중 예기치 못한 문제가 발생하였습니다</p>
        <div className="flex gap-2">{customButton ? customButton : <RedirectButton />}</div>
      </div>
    </Page>
  );
}
